<template>
    <div class="flow">
        <!--<top_nav class="help_nav"></top_nav>-->
        <div class="bg_box">
            <!--<img src="../../assets/images/bg/help_bg.png" alt="">-->
            <div class="bg_con">嘉联华
                <div class="bg_dot"></div>
                竞拍流程
            </div>
        </div>
        <div class="subfield_box">
            <div class="subfield_left_box">
                <div class="subfield_left">
                    <div class="subfield_left_item" v-for="item in list" :key="item.id"
                         :class="{tabActive:leftTab === item.id}" @click="changeTab(item.id)">
                        {{ item.title}}
                    </div>
                </div>
            </div>
            <div class="subfield_right_box">
                <div class="subfield_right">
                    <div class="subfield_right_con" v-html="item.content" v-show="leftTab === item.id"
                         v-for="item in list" :key="item.id">
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script type="text/ecmascript-6">
	// import top_nav from '../../components/nav.vue'
	import {flows} from "../../apiNew/index";

	export default {
		name: '',
		data() {
			return {
				leftTab: '',
				list: '',
				// total: 0,
				// page: 0,
				// limit: 10,
			}

		},
		components: {
			// top_nav
		},
		created() {

		},
		mounted() {
			this.init()
		},
		methods: {
			init() {
				flows({
					category_id: localStorage.getItem('categoryId')
				}).then(res => {
					console.log(res)
					this.list = res.data
					if (res.data.length > 0) {
						this.leftTab = res.data[0].id
					}
					this.total = res.data.total
				}).catch(error => {
					console.log(error)
					// this.$dialog.toast({
					// 	mes: error.message,
					// 	timeout: 1000,
					// 	type: "error"
					// });
				})
			},
			changeTab(n) {
				this.leftTab = n
			}
		}
	}
</script>

<style lang="less" rel="stylesheet/less" scoped>
    @import "flow";
</style>